import moment from "moment-timezone";

export const DATE_RANGE_TYPE = {
  DEFAULT: "DEFAULT",
  THIS_WEEK: "THIS_WEEK",
  LAST_WEEK: "LAST_WEEK",
  LAST_2_WEEKS: "LAST_2_WEEKS",
  THIS_MONTH: "THIS_MONTH",
  LAST_MONTH: "LAST_MONTH",
  LAST_MONTH_TO_TODAY: "LAST_MONTH_TO_MTD",
  LAST_3_MONTHS: "LAST_3_MONTHS",
  LAST_6_MONTHS: "LAST_6_MONTHS",
  LAST_9_MONTHS: "LAST_9_MONTHS",
  LAST_1_YEAR: "LAST_1_YEAR",
  LAST_2_YEARS: "LAST_2_YEARS",
  LAST_FULL_YEAR: "LAST_FULL_YEAR",
};
export const DATE_RANGES = [
  DATE_RANGE_TYPE.THIS_MONTH,
  DATE_RANGE_TYPE.LAST_MONTH,
  DATE_RANGE_TYPE.LAST_3_MONTHS,
];
export const DATE_FORMAT = "YYYY-MM-DD";

export const MIN_DATE = moment()
  .subtract(120, "days")
  .startOf("month")
  .toDate();

export function getDateRangeByType(type) {
  const now = moment().startOf("day");
  let startDate, endDate;

  switch (type) {
    case DATE_RANGE_TYPE.DEFAULT: {
      // if curreny day is before the 7th, also show last month data
      if (now.date() <= 7) {
        const d = now.clone().subtract(1, "month");
        startDate = d.startOf("month");
      } else {
        startDate = now.clone().startOf("month");
      }
      endDate = now;
      break;
    }

    case DATE_RANGE_TYPE.THIS_WEEK: {
      startDate = now.clone().startOf("week");
      endDate = now;
      break;
    }

    case DATE_RANGE_TYPE.LAST_WEEK: {
      const d = now.clone().subtract(1, "week");
      startDate = d.startOf("week");
      endDate = d.clone().endOf("week");
      break;
    }

    case DATE_RANGE_TYPE.LAST_2_WEEKS: {
      const d = now.clone().subtract(2, "week");
      startDate = d.startOf("week");
      endDate = d.clone().add(1, "week").endOf("week");
      break;
    }

    case DATE_RANGE_TYPE.THIS_MONTH: {
      startDate = now.clone().startOf("month");
      endDate = now;
      break;
    }

    case DATE_RANGE_TYPE.LAST_MONTH: {
      const d = now.clone().subtract(1, "month");
      startDate = d.startOf("month");
      endDate = d.clone().endOf("month");
      break;
    }

    case DATE_RANGE_TYPE.LAST_MONTH_TO_TODAY: {
      const d = now.clone().subtract(1, "month");
      startDate = d.startOf("month");
      endDate = now;
      break;
    }

    case DATE_RANGE_TYPE.LAST_3_MONTHS: {
      const d = now.clone().subtract(3, "month");
      startDate = d.startOf("month");
      endDate = now;
      break;
    }

    case DATE_RANGE_TYPE.LAST_6_MONTHS: {
      const d = now.clone().subtract(6, "month");
      startDate = d.startOf("month");
      endDate = now.subtract(1, "month").endOf("month");
      break;
    }

    case DATE_RANGE_TYPE.LAST_9_MONTHS: {
      const d = now.clone().subtract(9, "month");
      startDate = d.startOf("month");
      endDate = now.subtract(1, "month").endOf("month");
      break;
    }

    case DATE_RANGE_TYPE.LAST_1_YEAR: {
      const d = now.clone().subtract(1, "year");
      startDate = d.startOf("month");
      endDate = now.subtract(1, "month").endOf("month");
      break;
    }

    case DATE_RANGE_TYPE.LAST_FULL_YEAR: {
      const d = now.clone().subtract(1, "year");
      startDate = d.startOf("year");
      endDate = d.clone().endOf("year");
      break;
    }

    case DATE_RANGE_TYPE.LAST_2_YEARS: {
      const d = now.clone().subtract(2, "year");
      startDate = d.startOf("month");
      endDate = now.subtract(1, "month").endOf("month");
      break;
    }

    default: {
      //
    }
  }

  const sd = startDate.format(DATE_FORMAT);
  const ed = endDate.format(DATE_FORMAT);
  return {
    startDate: sd,
    endDate: ed,
  };
}
